import { postsByCategory } from '../api'
import pagination from '../pagination'
import select from '../select'
import morePost from '../more-post'

const search = {
  elements: {
    button: document.querySelector('.CardSearchWrapper-btn'),
    container: document.querySelector('.Search-features')
  },

  markup: ({ data }) => {
    return data
      .map(
        ({ title, excerpt_post, url, featured_media_post, author_name, link }) =>
          `
          <a class="Search-features-card" href='${url ? url : link}' title='${is_object(title) ? title.rendered : title}'>
            ${
              !!featured_media_post
                ? `
                  ${featured_media_post}
                  `
                : ''
            }

            <div class="Search-features-card-content">
              <h3 class="Search-features-card-title">${is_object(title) ? title.rendered : title}</h3>
              <p></p>
              <p class="Search-features-card-excerpt">${excerpt_post}</p>
              <p></p>
            </div>

            <div class="Search-features-card-footer">
              <div class="Search-features-card-author">Por <strong>${author_name}</strong></div>
              <div class="Search-features-card-btn Btn Btn-christi">` + clubei18n.lermais + `</div>
            </div>
          </a>
        `
      )
      .join('')
  },

  loading: () => (
    `
    <span className="circle circle-1"></span>
    <span className="circle circle-2"></span>
    <span className="circle circle-3"></span>
    `
  ),

  init: async ({ ...props }) => {
    const url = new URL(window.location)
    const container = search.elements.container

    if( ! document.querySelector('.CardSearchWrapper') ) {
      return;
    }

    // set per page
    let perPage = 6
    if (window.innerWidth < 576) { // check mobile
      perPage = 3
    } else if (window.innerWidth >= 992) {
      perPage = 6
    }

    if (container) {
      var loadingElement = document.createElement('div');
      const searchFeatures = document.querySelector('.Search-features');

      container.classList.add('loading');
      loadingElement.classList.add('List-loading');
      loadingElement.innerHTML = search.loading();
      container.parentElement.insertBefore(loadingElement, searchFeatures);
    }
    const { data, totalPages, pageCurrent } = await postsByCategory(
      { ...props, postType: postType, perPage: perPage,
        search: searchQuery })

    const list = await data

    if (loadingElement) {
      loadingElement.remove()
    }

    if (!list.length) {
      if (container) {
        container.innerHTML = '<h2>' + clubei18n.nenhumresultado + '</h2>'
        document.querySelector('.Pagination').style.display = 'none'
      }

      return
    }

    if (container) {
      container.innerHTML = await search.markup({ data: list })
      container.classList.remove('loading')
    }

    url.searchParams.set('pagina', pageCurrent)
    window.history.pushState({}, '', url)

    if (search.elements.button) {
      search.elements.button.classList.remove('loading')
    }

    if (totalPages === pageCurrent && search.elements.button) {
      search.elements.button.style.display = 'none'
    }

    pagination.init({ totalPages, pageCurrent, postType: postType, search: searchQuery, wrapper: '.CardSearchWrapper' })
  }
}

const isMobile = window.innerWidth < 576
const url = new URL(window.location)
const pageCurrent = url.searchParams.get('pagina')
const searchQuery = url.searchParams.get('s')
const firstPage = Number(pageCurrent) === 1 ? 0 : Number(pageCurrent)
const postType = searchQuery ? 'search' : 'author';

const initialState = {
  pageCurrent: Number(pageCurrent) || 1,
  perPage: isMobile ? 3 : 6,
  offset: isMobile ? firstPage * 3 - 3 : '',
  typePost: postType,
  searchQuery: searchQuery,
  layout: 'search'
}

search.init({ ...initialState })
if (select && document.querySelector('.CardSearchWrapper')) {
  select.init({ ...initialState })
  morePost.init({ ...initialState })
}

function is_object( val ) {
  return (typeof val === 'object');
}

export default search
